export default __webpack_public_path__ + "static/media/Lobby.001ba9aa.webp";